"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromNodeProviderChain = void 0;
const credential_provider_node_1 = require("@aws-sdk/credential-provider-node");
const fromNodeProviderChain = (init = {}) => (0, credential_provider_node_1.defaultProvider)({
    ...init,
});
exports.fromNodeProviderChain = fromNodeProviderChain;
